import actions from '../../actionTypes';

export default (searchText) => {
  return {
    type: actions.FILTER_GROUP,
    searchText
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/getFilteredGroups.js